import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useEffect, useMemo, useState } from "react";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Box, Typography } from "@mui/material";
import HeroCst from "@components/HeroCst";

const HeroProject: React.FC = () => {
  const [statusColor, setStatusColor] = useState<string>();
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const { idProject, id } = useParams();
  const { t: tInput } = useTranslation(["input"]);

  const { dataDetail } = useFetchDataDetail(
    `${ServicesURL.getProjects}/${idProject}?corporateId=${id}`,
    PagesID["projects"],
  );

  const statusColorObj = useMemo(() => {
    switch (dataDetail?.dto?.status.toLowerCase()) {
      case "under_development":
        return theme.palette.status.gap_completed;
      case "pending_activation":
        return theme.palette.status.in_progress;
      case "active":
        return theme.palette.status.completed;
      case "closed":
        return theme.palette.status.canceled;
      default:
        return theme.palette.text.primary;
    }
  }, [dataDetail?.dto?.status]);

  useEffect(() => {
    setStatusColor(statusColorObj);
    setIsVisible(true);
  }, [statusColorObj]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
      }}
    >
      <HeroCst
        title={
          dataDetail && dataDetail.dto
            ? `${dataDetail.dto.code ?? ""} - ${dataDetail.dto.title ?? ""}`
            : ""
        }
        description={""}
      />

      {isVisible && dataDetail?.dto?.status && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "24px 0 40px",
          }}
        >
          <Box
            sx={{
              border: "2px solid",
              borderRadius: 3,
              px: 2,
              py: 1,
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: "8px",
              color: statusColorObj,
            }}
          >
            <FiberManualRecordIcon sx={{ fontSize: 20 }} />
            <Typography variant="body2" fontWeight={500}>
              {tInput(
                `options.project_status.${(dataDetail?.dto?.status ?? "").toLowerCase()}`,
              )}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HeroProject;
